import React from 'react';
import {ScrollView, TouchableOpacity, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useSelector} from 'react-redux';
import FastImage from '../../Utils/FastImage';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

///////////////////////////
///////////// components
import {navigationRef} from 'src/Nav/navigationHelpers';
import {
  BodyText,
  CloseIconButton,
  MultiChoiceAnswer,
} from 'src/Modules/CommonView';
import {useChallenge, useImageSource} from '../../Hooks/gameHooks';

import ChallengeFeedbackElement from '../Game/ChallengeFeedbackElement';

const ChallengeResultModal = (props = {}) => {
  const players = useSelector((state) => state.groupInfo?.players);
  const teamName = useSelector((state) => state.groupInfo?.teamName);
  const imageSource = useImageSource();
  const challenge = useChallenge();
  const {width, height} = useWindowDimensionsSafe();

  const {
    question = '',
    answers = [],
    completions = {},
    type,
    postContent = '',
    playerPointsEarned = 0,
    groupPointsEarned,
  } = challenge || {};

  const totalPointsEarned = playerPointsEarned + (groupPointsEarned || 0) || 0;

  return (
    <SafeAreaView
      style={{
        flex: 1,
        justifyContent: 'flex-end',
      }}>
      <View>
        <TouchableOpacity
          style={{flex: 1}}
          onPress={() => navigationRef.goBack(null)}
        />
        <View style={{maxHeight: height - 60}}>
          <ScrollView>
            <View
              style={{
                width,
                backgroundColor: global?.color?.white,
                borderRadius: 10,
                paddingVertical: 5,
                position: 'relative',
              }}>
              <View style={{alignItems: 'center'}}>
                <FastImage
                  style={{
                    width: width - 20,
                    height: 210,
                  }}
                  source={imageSource}
                  resizeMode={FastImage?.resizeMode?.contain}
                />
              </View>

              <View style={{marginTop: 0, marginBottom: 10}}>
                <BodyText
                  text={'Result'}
                  textStyle={{
                    textAlign: 'center',
                    fontWeight: '700',
                    fontSize: 18,
                    lineHeight: 20,
                  }}
                />
                <BodyText text={question} />
              </View>
              <MultiChoiceAnswer
                answers={answers}
                completions={completions}
                teamName={teamName}
                players={players}
                postContent={postContent}
                isPhoto={type === 'ispy'}
                pointsEarned={totalPointsEarned > 0 ? totalPointsEarned : 0}
              />
              <ChallengeFeedbackElement {...props} isSmiley />

              <CloseIconButton
                testID={'CloseIconButtonClose'}
                handlePress={() => navigationRef.goBack(null)}
                side="right"
              />
            </View>
          </ScrollView>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default ChallengeResultModal;
